<script setup lang="ts">
import SemboLogo from '@apps/main/new-desktop/core/components/SemboLogo.vue';
import {
  usePaxStore,
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';
import { CoreEventSource } from '@apps/main/new-desktop/core/models';

import { AppBackButton } from '@libs/ui';

import FirstDayTripPriceRibbon from '../../../core/components/FirstDayTripPriceRibbon.vue';
import { PaxSelectorButtonWhite } from '../../../modules/paxSelector';
import { useHotelSelectionModalsStore } from '../stores';

const hotelSelectionModalsStore = useHotelSelectionModalsStore();
const paxStore = usePaxStore();
const routerStore = useRouterStore();
const statsigEventsStore = useStatsigEventsStore();

function onBackButtonClick(): void {
  routerStore.navigateToTripOverview();
  statsigEventsStore.logHotelSelectionBackButtonClicked();
}

function onNavigationTriggered(): void {
  statsigEventsStore.logHotelSelectionBackButtonClicked();
}
</script>

<template>
  <div class="hotel-selection-header">
    <div class="buttons-wrapper">
      <SemboLogo class="logo" color="color-primary-70" />
      <div class="divider" />
      <AppBackButton
        type="black"
        :text="$t('planner.back')"
        :link="routerStore.getTripOverviewUrl()"
        font="font-label-l-bold"
        @click="onBackButtonClick"
        @navigation-triggered="onNavigationTriggered"
      />

      <div class="divider" />
      <PaxSelectorButtonWhite
        :button-text="paxStore.getPaxesButtonSimpleText"
        :children-ages="paxStore.paxesChildrenAgesText"
        @click="hotelSelectionModalsStore.openPaxSelectorModal()"
      />
    </div>
    <div class="calendar-wrapper">
      <FirstDayTripPriceRibbon
        :show-month-select-dropdown="false"
        :source="CoreEventSource.HotelSelection"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-header {
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-secondary-93);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  overflow: hidden;

  .buttons-wrapper {
    display: flex;
    align-items: center;

    margin-right: 0;
    height: 96px;

    border-bottom: 1px solid var(--color-scrollbar);
    border-right: 1px solid var(--color-scrollbar);

    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 var(--spacing-32);
      height: 100%;
      transition: all var(--transition-short);

      @include on-hover {
        cursor: pointer;
        background-color: var(--color-secondary-93);
      }
    }

    .divider {
      width: 1px;
      height: 100%;
      background-color: var(--color-secondary-93);
    }
  }

  .calendar-wrapper {
    overflow: hidden;
    padding: 0;
  }
}
</style>
